import React, { useState }  from "react";
import "./HomePage.css";
import "../index.css";
import { LeftVector, RightVector } from "../../assets";
import { SmartQuest, UserAvatar } from "../../assets";
import { Link } from "react-router-dom";
import Spinner from "../../components/ui/Spinner/Spinner";
import { useGetMe } from "../../hooks/useGetMe";
import { NavLink, useNavigate } from "react-router-dom";
import { useNotifications } from "../../hooks/useNotifications";
import {
  FaCommentAlt,
  FaBell,
  FaChevronDown,
  FaUniversity,
  FaUsers,
  FaDatabase,
  FaEnvelope,
  FaWpforms,
  FaSignOutAlt
} from "react-icons/fa";

const HomePage = () => {
  const { user, loading } = useGetMe();
  const navigate = useNavigate();

  const { messageNotifs, responseNotifs, setMessageNotifs, setResponseNotifs } =
    useNotifications(user?.id);

  const [showMessages, setShowMessages] = useState(false);
  const [showResponses, setShowResponses] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);

  if (loading) return <Spinner size="lg" color="#EF4346" />;

  return (
    <div className="container-fluid vh-100">
      {/* Background */}
      <div>
        <img src={LeftVector} alt="left" className="vibrate-1 leftImageStyle" />
        <img
          src={RightVector}
          alt="Right"
          className="vibrate-2 rightImageStyle"
        />
      </div>

      {/* Navbar */}
      <nav className="navbar bg-body" style={{ height: "60px" }}>
        <div className="container-fluid mt-2 mb-4">
          {/* Left: Logo */}
          <div className="d-flex align-items-center justify-content-start ms-2 cursor-pointer">
            <NavLink to="/home">
              <img
                src={SmartQuest}
                alt="SmartQuest Name"
                className="logoName_nav"
              />
            </NavLink>
          </div>

          {/* Right: Notifications & User */}
          <div className="d-flex align-items-center justify-content-end position-relative">
            {/* Messages */}
            <div className="notif-wrapper mx-2">
              <div
                className="notif-icon-container"
                onClick={() => {
                  setShowMessages((prev) => !prev);
                  setShowResponses(false);
                  setShowUserMenu(false);
                }}
              >
                <FaCommentAlt className="notif-icon" />
                {messageNotifs.length > 0 && (
                  <span className="notif-badge">{messageNotifs.length}</span>
                )}
              </div>

              {showMessages && (
                <div className="notif-dropdown">
                  <div className="notif-header">📨 Nouveaux messages</div>
                  {messageNotifs.length === 0 ? (
                    <div className="notif-empty">Aucun nouveau message</div>
                  ) : (
                    messageNotifs.map((msg, index) => (
                      <div
                        key={index}
                        className="notif-item"
                        onClick={() => {
                          navigate("/messagerie");
                          setShowMessages(false);
                        }}
                      >
                        <strong>De:</strong> {msg.from || "Utilisateur inconnu"}
                        <div className="notif-content">{msg.content}</div>
                      </div>
                    ))
                  )}
                  <div
                    className="notif-footer"
                    onClick={() => setMessageNotifs([])}
                  >
                    Marquer comme lu
                  </div>
                </div>
              )}
            </div>

            {/*  Form responses */}
            <div className="notif-wrapper mx-3">
              <div
                className="notif-icon-container"
                onClick={() => {
                  setShowResponses((prev) => !prev);
                  setShowMessages(false);
                  setShowUserMenu(false);
                }}
              >
                <FaBell className="notif-icon" />
                {responseNotifs.length > 0 && (
                  <span className="notif-badge">{responseNotifs.length}</span>
                )}
              </div>

              {showResponses && (
                <div className="notif-dropdown">
                  <div className="notif-header">📄 Nouvelles réponses</div>
                  {responseNotifs.length === 0 ? (
                    <div className="notif-empty">Aucune nouvelle réponse</div>
                  ) : (
                    responseNotifs.map((r, i) => (
                      <div
                        key={i}
                        className="notif-item"
                        onClick={() => {
                          navigate("/formulaires");
                          setShowResponses(false);
                        }}
                      >
                        <strong>Formulaire :</strong>{" "}
                        {r.formTitle || "Formulaire inconnu"}
                        <div className="notif-content">
                          Soumis par {r.submitted_by || "Utilisateur inconnu"}
                        </div>
                      </div>
                    ))
                  )}
                  <div
                    className="notif-footer"
                    onClick={() => setResponseNotifs([])}
                  >
                    Marquer comme lu
                  </div>
                </div>
              )}
            </div>

            {/*  User Info */}
            <div className="user-menu-wrapper mx-2 position-relative">
              {user && (
                <>
                  <div
                    className="d-flex align-items-center cursor-pointer user-toggle"
                    onClick={() => {
                      setShowUserMenu((prev) => !prev);
                      setShowMessages(false);
                      setShowResponses(false);
                    }}
                  >
                    {/*  On large screens: name + avatar */}
                    <span className="user-name d-none d-md-inline">
                      Dr. {user.first_name} {user.last_name}
                    </span>

                    {/*  Avatar always visible */}
                    <img
                      src={UserAvatar}
                      alt="Profile"
                      className="mx-2 rounded-circle"
                      style={{ width: "35px", height: "35px" }}
                    />
                    <FaChevronDown className="user-chevron d-none d-md-inline" />
                  </div>

                  {showUserMenu && (
                    <div className="user-dropdown">
                      {/* Show name only on small screens */}
                      <div
                        className="user-dropdown-item d-md-none"
                        style={{ cursor: "default" }}
                      >
                        <strong>
                          Dr. {user.first_name} {user.last_name}
                        </strong>
                      </div>

                      <div
                        className="user-dropdown-item"
                        onClick={() => {
                          localStorage.removeItem("access_token");
                          navigate("/");
                        }}
                      >
                        <FaSignOutAlt className="me-2" /> Déconnexion
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </nav>

      {/* Main content */}
      <div className="h-75 position-absolute top-50 start-50 translate-middle w-100 d-flex flex-column align-items-center justify-content-center">
        <div className="home-div d-flex flex-column align-items-center justify-content-center px-5 pt-4">
          <div className="row w-100 h-100 justify-content-center">
            {/* Études */}
            <div className="col-6 col-md-4 d-flex justify-content-center mb-4">
              <div className="home-card d-flex align-items-center justify-content-center">
                <Link
                  to="/etudes"
                  className="link-home-card text-decoration-none d-flex flex-column align-items-center"
                >
                  <FaUniversity />
                  <h4 className="my-3" style={{ color: "rgba(104,104,104,1)" }}>
                    Études
                  </h4>
                </Link>
              </div>
            </div>

            {/* Formulaires */}
            <div className="col-6 col-md-4 d-flex justify-content-center mb-4">
              <div className="home-card d-flex align-items-center justify-content-center py-5 px-2">
                <Link
                  to="/formulaires"
                  className="link-home-card text-decoration-none d-flex flex-column align-items-center"
                >
                  <FaWpforms />
                  <h4 className="my-3" style={{ color: "rgba(104,104,104,1)" }}>
                    Formulaires
                  </h4>
                </Link>
              </div>
            </div>

            {/* Collaborateurs */}
            <div className="col-6 col-md-4 d-flex justify-content-center mb-4">
              <div className="home-card d-flex align-items-center justify-content-center py-5 px-2">
                <Link
                  to="/collaborateurs"
                  className="link-home-card text-decoration-none d-flex flex-column align-items-center"
                >
                  <FaUsers />
                  <h5 className="my-3">Collaborateurs</h5>
                </Link>
              </div>
            </div>

            {/* Base de données */}
            <div className="col-6 col-md-6 d-flex justify-content-end mb-4">
              <div className="home-card d-flex align-items-center justify-content-center py-5 px-2">
                <Link
                  to="/bases-de-donnees"
                  className="link-home-card text-decoration-none d-flex flex-column align-items-center"
                >
                  <FaDatabase />
                  <h4 className="my-3" style={{ color: "rgba(104,104,104,1)" }}>
                    Base de données
                  </h4>
                </Link>
              </div>
            </div>

            {/* Messagerie */}
            <div className="col-6 col-md-6 d-flex justify-content-start mb-4">
              <div className="home-card d-flex align-items-center justify-content-center py-5 px-2">
                <Link
                  to="/messagerie"
                  className="link-home-card text-decoration-none d-flex flex-column align-items-center"
                >
                  <FaEnvelope />
                  <h4 className="my-3" style={{ color: "rgba(104,104,104,1)" }}>
                    Messagerie
                  </h4>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
